import { render, staticRenderFns } from "./redInvoiceConfirm.vue?vue&type=template&id=104f643e&scoped=true&"
import script from "./redInvoiceConfirm.vue?vue&type=script&lang=js&"
export * from "./redInvoiceConfirm.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=104f643e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f643e",
  null
  
)

export default component.exports